import type { FirehoseMessageHandler } from '../firehose-message-router.js';

/** Firehose acknowledges `{ type: 'identify' }` with `{ type: 'identified', key }`. */
export const handleFirehoseIdentified: FirehoseMessageHandler = (_msg, _deps) => {
  /* identify acknowledged; no log (success path) */
};
